<template>
    <div class="card h-100 ui02-card mb-1">
        <div class="ui02-header d-flex align-items-center justify-content-between gap-2">
            <div class="d-flex align-items-center gap-2 min-w-0">
                <h3 class="ui02-card-title mb-0">Stato dei progetti</h3>
                <span class="ui02-total" :aria-label="'Totale progetti ' + progettiTotali">{{ progettiTotali }}</span>
            </div>
            <button type="button" class="ui02-showall" @click="mostraTutti">Mostra tutti</button>
        </div>

        <div class="card-body d-flex flex-column ui02-body">
            <div v-if="loading" class="placeholder-glow text-center py-4">
                <span class="placeholder col-8"></span>
            </div>

            <BlockState v-else-if="nonDisponibile" stato="non_disponibile"
                        dettaglio="La distribuzione per stato non è disponibile." />

            <p v-else-if="nienteDati" class="text-muted text-center mb-0">Nessun progetto nel periodo selezionato.</p>

            <template v-else>
                <!-- Box stati reali: ordine fisso Completati/In corso/In attesa/
                     Preventivi; nessuna icona. I conteggi arrivano dal payload. -->
                <div class="ui02-boxes mb-3" role="group" aria-label="Filtra i progetti per stato">
                    <button v-for="g in riquadri" :key="g.chiave" type="button"
                            class="ui02-box" :class="['ui02-box--' + g.tema, { 'is-active': gruppoAttivo.chiave === g.chiave }]"
                            :aria-pressed="gruppoAttivo.chiave === g.chiave ? 'true' : 'false'"
                            @click="seleziona(g.chiave)">
                        <span class="ui02-box-nome">{{ g.nome }}</span>
                        <span class="ui02-box-num">{{ g.progetti }}</span>
                    </button>
                </div>

                <!-- Elenco EVENTI: data evento | titolo | codice · cliente.
                     Filtraggio client-side (stessa logica UI-02, niente "Tutti"). -->
                <div class="ui02-lista flex-grow-1">
                    <ul v-if="progettiPaginati.length" class="list-unstyled mb-0">
                        <li v-for="p in progettiPaginati" :key="p.project_id" class="ui02-ev-row">
                            <div class="ui02-ev-date" aria-hidden="true">
                                <span class="ui02-ev-day">{{ giornoEvento(p) }}</span>
                                <span class="ui02-ev-month">{{ meseEvento(p) }}</span>
                            </div>
                            <div class="ui02-ev-body">
                                <button type="button" class="ui02-ev-titolo ui02-ev-titolo--link"
                                        :title="p.title" :disabled="!p.project_id"
                                        @click="$emit('apri-progetto', p.project_id)">{{ p.title || '—' }}</button>
                                <div class="ui02-ev-meta" :title="metadato(p)">{{ metadato(p) }}</div>
                            </div>
                        </li>
                    </ul>
                    <p v-else class="text-muted text-center mb-0">Nessun progetto in questo stato.</p>
                </div>

                <!-- Stessa struttura e classi della paginazione To Do. -->
                <nav v-if="maxProgetti > 0" class="nav-top ui02-paginazione mt-auto pt-2"
                     aria-label="Paginazione progetti">
                    <ul class="pagination">
                        <li class="page-item kt-pagination__link--first cursor-pointer"
                            :class="{ disabled: paginaCorrente <= 1 || pagineTotali <= 1 }">
                            <a class="page-link" href="#" aria-label="Prima pagina"
                               :aria-disabled="paginaCorrente <= 1 || pagineTotali <= 1"
                               :tabindex="paginaCorrente <= 1 || pagineTotali <= 1 ? -1 : 0"
                               @click.prevent="paginaCorrente > 1 && pagineTotali > 1 && vaiPagina(1)">&lt;&lt;</a>
                        </li>
                        <li class="page-item kt-pagination__link--prev cursor-pointer"
                            :class="{ disabled: paginaCorrente <= 1 || pagineTotali <= 1 }">
                            <a class="page-link" href="#" aria-label="Pagina precedente"
                               :aria-disabled="paginaCorrente <= 1 || pagineTotali <= 1"
                               :tabindex="paginaCorrente <= 1 || pagineTotali <= 1 ? -1 : 0"
                               @click.prevent="paginaCorrente > 1 && pagineTotali > 1 && vaiPagina(paginaCorrente - 1)">&lt;</a>
                        </li>
                        <li class="page-item kt-pagination__link--next cursor-pointer"
                            :class="{ disabled: paginaCorrente >= pagineTotali }">
                            <a class="page-link" href="#" aria-label="Pagina successiva"
                               :aria-disabled="paginaCorrente >= pagineTotali"
                               :tabindex="paginaCorrente >= pagineTotali ? -1 : 0"
                               @click.prevent="paginaCorrente < pagineTotali && vaiPagina(paginaCorrente + 1)">&gt;</a>
                        </li>
                        <li class="page-item kt-pagination__link--last cursor-pointer"
                            :class="{ disabled: paginaCorrente >= pagineTotali }">
                            <a class="page-link" href="#" aria-label="Ultima pagina"
                               :aria-disabled="paginaCorrente >= pagineTotali"
                               :tabindex="paginaCorrente >= pagineTotali ? -1 : 0"
                               @click.prevent="paginaCorrente < pagineTotali && vaiPagina(pagineTotali)">&gt;&gt;</a>
                        </li>
                    </ul>
                </nav>
            </template>
        </div>
    </div>
</template>

<script>
import BlockState from "./BlockState.vue";

/* Gruppi visuali fissi richiesti dal target UI-02B, nell'ordine esatto.
   La mappatura e' PRESENTAZIONALE e data-driven: usa le descrizioni degli stati
   reali restituite dal backend (stati.elenco). Stati non riconosciuti (es.
   "Chiuso") restano fuori dai quattro gruppi e sono raggiungibili tramite il
   filtro globale Stato. */
const GRUPPI = [
    { chiave: "COMPLETATI", nome: "Completati", tema: "green",  matcher: /complet/ },
    { chiave: "IN_CORSO",   nome: "In corso",   tema: "amber",  matcher: /corso/ },
    { chiave: "IN_ATTESA",  nome: "In attesa",  tema: "blue",   matcher: /attesa/ },
    { chiave: "PREVENTIVI", nome: "Preventivi", tema: "purple", matcher: /prevent/ },
];

const MESI = [null, "GEN", "FEB", "MAR", "APR", "MAG", "GIU",
    "LUG", "AGO", "SET", "OTT", "NOV", "DIC"];

export default {
    name: "ProjectStatusCard",
    components: { BlockState },

    props: {
        stati: { type: Object, default: null },
        progetti: { type: Object, default: null },
        loading: { type: Boolean, default: false },
        maxProgetti: { type: Number, default: 0 }, // 0 = nessun limite (default comportamento esistente)
    },

    data() {
        return {
            /* null = primo gruppo con progetti>0 (in ordine Completati...). */
            selezionato: null,
            /* Paginazione (solo quando maxProgetti > 0, ovvero in Dashboard Manager). */
            paginaCorrente: 1,
            elementiPerPagina: 5,
        };
    },
    computed: {
        nonDisponibile() {
            return !this.loading && (this.stati === null || this.stati === undefined
                || this.progetti === null || this.progetti === undefined);
        },
        elencoStati() {
            return (this.stati && Array.isArray(this.stati.elenco)) ? this.stati.elenco : [];
        },
        progettiTotali() {
            return this.progetti && typeof this.progetti.totale === "number" ? this.progetti.totale : 0;
        },
        progettiMostrati() {
            if (this.maxProgetti > 0) {
                const g = this.gruppoAttivo;
                if (!g || !g.stateIds || g.stateIds.length === 0) return 0;
                const filtered = this.progettiGrezzi.filter((p) => g.stateIds.indexOf(p.state_id) >= 0);
                return Math.min(filtered.length, this.elementiPerPagina);
            }
            return this.progetti && typeof this.progetti.mostrati === "number" ? this.progetti.mostrati : 0;
        },
        troncato() {
            if (this.maxProgetti > 0) {
                const g = this.gruppoAttivo;
                if (!g || !g.stateIds || g.stateIds.length === 0) return false;
                const filtered = this.progettiGrezzi.filter((p) => g.stateIds.indexOf(p.state_id) >= 0);
                return filtered.length > this.maxProgetti;
            }
            return this.progettiMostrati > 0 && this.progettiTotali > this.progettiMostrati;
        },
        progettiGrezzi() {
            return (this.progetti && Array.isArray(this.progetti.elenco)) ? this.progetti.elenco : [];
        },
        /* 4 box in ordine fisso; i conteggi derivano dagli stati REALI del
           payload che cadono in ciascun gruppo (mappatura presentazionale). */
        riquadri() {
            return GRUPPI.map((g) => {
                const stati = this.elencoStati.filter(
                    (s) => g.matcher.test(String(s.descrizione || "").toLowerCase()));
                return {
                    chiave: g.chiave,
                    nome: g.nome,
                    tema: g.tema,
                    progetti: stati.reduce((n, s) => n + (typeof s.progetti === "number" ? s.progetti : 0), 0),
                    stateIds: stati.map((s) => s.state_id),
                };
            });
        },
        /* Stato iniziale: primo gruppo con progetti>0 (preferenza Completati),
           altrimenti il primo in lista. Nessun quinto box "Tutti". */
        gruppoAttivo() {
            const r = this.riquadri;
            if (this.selezionato) {
                const g = r.find((x) => x.chiave === this.selezionato);
                if (g) return g;
            }
            return r.find((x) => x.progetti > 0) || r[0] || null;
        },
        progettiFiltrati() {
            const g = this.gruppoAttivo;
            if (!g || !g.stateIds || g.stateIds.length === 0) return [];
            const filtered = this.progettiGrezzi.filter((p) => g.stateIds.indexOf(p.state_id) >= 0);
            return filtered;
        },
        /* Paginazione: calcola pagine totali basandosi su maxProgetti (5) e elementi per pagina. */
        pagineTotali() {
            if (this.maxProgetti <= 0) return 1;
            return Math.max(1, Math.ceil(this.progettiFiltrati.length / this.elementiPerPagina));
        },
        progettiPaginati() {
            if (this.maxProgetti <= 0) return this.progettiFiltrati;
            const start = (this.paginaCorrente - 1) * this.elementiPerPagina;
            return this.progettiFiltrati.slice(start, start + this.elementiPerPagina);
        },
        mostraPaginazione() {
            return this.maxProgetti > 0 && this.pagineTotali > 1;
        },
        nienteDati() {
            return this.progettiTotali === 0 && this.progettiGrezzi.length === 0;
        },
    },

    watch: {
        pagineTotali() {
            this.vaiPagina(this.paginaCorrente);
        },
    },

    methods: {
        vaiPagina(pagina) {
            const n = Number(pagina);
            if (!Number.isFinite(n)) return;
            this.paginaCorrente = Math.max(1, Math.min(this.pagineTotali, Math.trunc(n)));
        },
        seleziona(chiave) {
            this.selezionato = chiave;
            this.paginaCorrente = 1; // reset paginazione al cambio filtro
        },
        mostraTutti() {
            if (this.$router && typeof this.$router.push === "function") {
                this.$router.push({ name: "Progetti" });
            }
        },
        /* Presentazione (data-driven): gruppo per la descrizione di uno stato reale. */
        gruppoStato(nome) {
            const n = String(nome || "").toLowerCase();
            const g = GRUPPI.find((x) => x.matcher.test(n));
            return g ? g.chiave : null;
        },
        /* DATA EVENTO reale dal payload: date_event = THEB_PROGETTI.DATA_INIZIO_EVENTO. */
        giornoEvento(p) {
            const s = String((p && p.date_event) || "");
            return s.split("-")[2] || "–";
        },
        meseEvento(p) {
            const s = String((p && p.date_event) || "");
            const m = parseInt(s.split("-")[1], 10);
            return (m >= 1 && m <= 12) ? MESI[m] : "";
        },
        /* Meta dell'evento: CODICE · CLIENTE (senza altre colonne). */
        metadato(p) {
            const c = (p && p.code) || "";
            const cl = (p && p.cliente) || "";
            return [c, cl].map((v) => String(v).trim()).filter(Boolean).join(" · ");
        },
    },
};
</script>

<style scoped>
.ui02-card {
    display: flex;
    flex-direction: column;
    border: 1px solid #e9edf2;
    border-radius: 16px;
    box-shadow: 0 1px 3px rgba(15, 23, 42, .05);
    overflow: hidden;
}
.ui02-header {
    height: 60px;
    padding: 0 18px;
    border-bottom: 1px solid #eef1f6;
    background: #fff;
    flex-shrink: 0;
}
.ui02-card-title {
    font-size: 1.06rem;
    font-weight: 700;
    color: #1f2a37;
    letter-spacing: -.01em;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.min-w-0 { min-width: 0; }
/* Badge TOTALE accanto al titolo. */
.ui02-total {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 26px;
    height: 22px;
    padding: 0 8px;
    border-radius: 999px;
    background: #e7f1ff;
    color: #0d6efd;
    font-size: .78rem;
    font-weight: 700;
    flex-shrink: 0;
}
/* Soft button MOSTRA TUTTI (senza freccia). */
.ui02-showall {
    display: inline-flex;
    align-items: center;
    padding: 8px 12px;
    border: 1px solid transparent;
    border-radius: 10px;
    background-color: #e7f1ff;
    color: #0d6efd;
    font-size: .78rem;
    font-weight: 600;
    line-height: 1;
    flex-shrink: 0;
}
.ui02-showall:hover {
    background-color: #d9e9ff;
    color: #0a58ca;
}
.ui02-body {
    flex: 1 1 auto;
    min-height: 0;
}
/* Box di stato: nessuna icona, solo nome + numero, tema soft. */
.ui02-boxes {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 10px;
}
.ui02-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 2px;
    min-height: 66px;
    padding: 10px 6px;
    border: 1px solid #e9edf2;
    border-radius: 12px;
    background: #fbfcfe;
    cursor: pointer;
    transition: box-shadow .15s ease, background-color .15s ease, border-color .15s ease;
}
.ui02-box-nome {
    font-size: .7rem;
    font-weight: 600;
    color: #475569;
    text-align: center;
    line-height: 1.15;
}
.ui02-box-num {
    font-size: 1.25rem;
    font-weight: 700;
    color: #1f2a37;
    line-height: 1;
}
.ui02-box--green  { border-color: #d7efe1; background: #f1fbf5; }
.ui02-box--amber  { border-color: #f6e2c3; background: #fdf7ee; }
.ui02-box--blue   { border-color: #cfe5ff; background: #f1f7ff; }
.ui02-box--purple { border-color: #e4d9f7; background: #f8f4fe; }
.ui02-box--green .ui02-box-num  { color: #168a4c; }
.ui02-box--amber .ui02-box-num  { color: #b45309; }
.ui02-box--blue .ui02-box-num   { color: #0a58ca; }
.ui02-box--purple .ui02-box-num { color: #6b3cc4; }
/* Selected: ring interno + background piu' presente (no scale). */
.ui02-box.is-active {
    box-shadow: inset 0 0 0 2px currentColor;
}
.ui02-box--green.is-active  { box-shadow: inset 0 0 0 2px #22a55f; background: #e3f7ec; }
.ui02-box--amber.is-active  { box-shadow: inset 0 0 0 2px #e58a0e; background: #fdf1df; }
.ui02-box--blue.is-active   { box-shadow: inset 0 0 0 2px #0d6efd; background: #e3efff; }
.ui02-box--purple.is-active { box-shadow: inset 0 0 0 2px #8056d6; background: #f2ebff; }
/* Lista eventi: scroll interno. */
.ui02-lista {
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
    scrollbar-width: thin;
    scrollbar-color: #cbd5e1 transparent;
}
.ui02-lista::-webkit-scrollbar { width: 6px; }
.ui02-lista::-webkit-scrollbar-track { background: transparent; }
.ui02-lista::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 4px; }
/* Riga evento: data | titolo · codice/cliente. */
.ui02-ev-row {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 10px 4px;
    border-bottom: 1px solid #f1f5f9;
}
.ui02-ev-row:last-child {
    border-bottom: 0;
}
.ui02-ev-date {
    flex-shrink: 0;
    width: 46px;
    text-align: center;
    border-radius: 10px;
    background: #f7f9fc;
    padding: 6px 2px;
}
.ui02-ev-day {
    display: block;
    font-size: 1.05rem;
    font-weight: 700;
    color: #1f2a37;
    line-height: 1.1;
}
.ui02-ev-month {
    display: block;
    font-size: .62rem;
    font-weight: 600;
    color: #64748b;
    text-transform: uppercase;
    letter-spacing: .04em;
    margin-top: 1px;
}
.ui02-ev-body {
    min-width: 0;
    flex: 1 1 auto;
}
.ui02-ev-titolo {
    font-size: .9rem;
    font-weight: 600;
    color: #1f2a37;
    line-height: 1.25;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
/* Titolo navigabile: conserva ellissi e tipografia originale. */
.ui02-ev-titolo--link {
    display: block;
    max-width: 100%;
    width: 100%;
    padding: 0;
    border: 0;
    background: transparent;
    text-align: left;
    cursor: pointer;
}
.ui02-ev-titolo--link:hover:not(:disabled),
.ui02-ev-titolo--link:focus-visible { color: #2563eb; text-decoration: underline; }
.ui02-ev-titolo--link:disabled { cursor: default; }
.ui02-ev-meta {
    font-size: .75rem;
    color: #64748b;
    margin-top: 2px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
/* Altezza desktop: NON piu' una forzatura locale. La card riempie la
   colonna (h-100) e quindi l'altezza calcolata dal parent; header e box
   restano fissi, solo la lista eventi scorre (overflow-y: auto). */
/* Nessuna ricostruzione dello stile: si usano le classi globali della To Do. */
.ui02-paginazione { width: 100%; }
.ui02-paginazione .pagination { margin-bottom: 0; }
</style>